module.exports = __webpack_public_path__ + "img/P16_19800746-010.1dd943a8.jpg";